import React, { useEffect } from 'react';
import { useEditorStore } from '../editor-store';
import { TalkToJourneyMessage } from './types';
import { Journey } from 'src/common/interfaces/journey.interface';
import { TalkToJourneyButton } from './button';
import { useTalkToJourneyStore } from './store';
import { useCurrentOrganization } from 'src/store/organization';

export const TalkToJourneyButtonEditor = ({ journey }: { journey: Journey }) => {
  const currentOrganization = useCurrentOrganization((state) => state.currentOrganization);
  const findBlockByContentUuid = useEditorStore((state) => state.findBlockByContentUuid);
  const findSectionById = useEditorStore((state) => state.findSectionById);
  const setScrollToBlockId = useEditorStore((state) => state.setScrollToBlockId);
  const setScrollToSectionId = useEditorStore((state) => state.setScrollToSectionId);
  const initVariablesFromJourney = useTalkToJourneyStore((state) => state.initVariablesFromJourney);

  const onSourceClick = (message: TalkToJourneyMessage) => {
    const { source_content_uuid, source_node_uuid } = message;
    if (source_content_uuid) {
      const block = findBlockByContentUuid(source_content_uuid);
      if (block) {
        setScrollToBlockId(block.id);
      }
    } else if (source_node_uuid) {
      const section = findSectionById(source_node_uuid);
      if (section) {
        setScrollToSectionId(section.id);
      }
    }
  };

  useEffect(() => {
    if (journey.uuid) {
      initVariablesFromJourney(journey, currentOrganization, 'editor');
    }
  }, [journey.uuid]);

  return (
    <TalkToJourneyButton
      journeyUUID={journey.uuid}
      layoutMode='web'
      onSourceClick={onSourceClick}
      findBlockByContentUuid={findBlockByContentUuid}
      findSectionById={findSectionById}
      inEditor={true}
    />
  );
};
